import React from 'react'
import {Navigate, Route, Routes, useLocation, useMatch, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from "react-redux";

import {ErrorBoundary, Footer, Header} from "./components/index";
import Login from "./views/_Pages/Login/Login";
import Home from './containers/Home/Home'
import {loadStorage} from "./sessionStorage";
import {breadcrumbActions, configurationActions} from './actions/index';
import { fetchConfig } from './store/configSlice';
import {ErrorPage} from "./views/_Pages/ErrorPage/ErrorPage";
import * as _ from "lodash";
import { corsoCorsiActions } from './slices/corso_corsiSlice';
import { cancelAllRequests } from './axios_instance';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isPwa } from './fanctionUtility';

export const App = () => {

    const navigate = useNavigate();
    const {pathname} = useMatch(useLocation().pathname);

    const configurationFile = useSelector((state) => state.configurationFile.fileConf);
    const config = useSelector(state => state.config.data);
    const authToken = useSelector(state => state.auth.token);

    const dispatch = useDispatch();

    const updateBreadcrumb = React.useCallback((path) => dispatch(breadcrumbActions.updateBreadcrumb(path)), [dispatch]);
    const getConfigFile = React.useCallback(() => dispatch(configurationActions.getConfigStart()), [dispatch]);

    React.useEffect(() => {
        if (
            !window.location.href.includes('registro?cognome=') && 
            !window.location.href.includes('profiliorariFSE/dettaglio')
        ) {
            cancelAllRequests();
        }
    }, [window.location.href]);


    React.useEffect(() => {
        getConfigFile();
    }, [getConfigFile]);

    React.useEffect(() => {
        if (authToken && !config) {
            dispatch(fetchConfig());
        }
    }, [authToken, config, dispatch]);

    React.useEffect(() => {
        dispatch(corsoCorsiActions.getCorsoFail(false))
        if (_.isEmpty(loadStorage()) || !loadStorage().auth.token) {
            if (pathname !== '/login') {
                navigate('/login', {replace: true});
            }
        } else {
            updateBreadcrumb(pathname);
        }

    }, [
        configurationFile,
        pathname,
        navigate,
        updateBreadcrumb
    ]);

    React.useMemo(() => {
        if (isPwa()) {
            document.querySelector('#root').style.display = 'block'
        }
    })

    serviceWorkerRegistration.unregister();

    return (
        <ErrorBoundary>
            <Header/>
            <main className="h-100 bg-white mt-2"
                  style={{padding: isPwa() ? '.5rem' : '1rem 1.5rem', maxWidth: '100vw', gridArea: isPwa() ? '' : "main"}}>
                <Routes>
                    <Route path="/error" name="Error Page" element={<ErrorPage/>}/>
                    <Route path="*" element={(_.isEmpty(loadStorage()) || !loadStorage().auth.token) ?
                        <Navigate replace to="/login"/> : <Home/>}/>
                    <Route path="/login" element={<Login/>}/>
                </Routes>
            </main>
            <Footer/>
        </ErrorBoundary>
    )
}

